<template>
    <div class="flat-crm-card-payment-hypothec" v-if="flatsCardParams != null">
        <div class="column-container">
            <div class="column-left">
                <div class="col-titles">
                    <!-- <h2>Стоимость квартиры</h2> -->
                    <div class="price" v-if="initPrices">
                        <ul>
                            <li>
                                <div class="info-label">{{flatsPage.on_hyp_word_cost}}</div>
                                <div class="info-value info-value-price">от {{ flatsCardParams.price }} <svgIcon name="tenge" class="icon-tenge"/></div>
                            </li>
                            <li>
                                <div class="info-label">{{flatsPage.on_hyp_word_price}}</div>
                                <div class="info-value">от {{ flatsCardParams.price_meter }} <svgIcon name="tenge" class="icon-tenge"/></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-calculator">
                    <div class="calculator-item calculator-item-price">
                        <div class="calculator-input">
                            <label>{{flatsPage.on_hyp_word_first_pay}}</label>
                            <br>
                            <input type="number" name="initPrice" class="form-control" v-model.lazy="initPrice" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                            <!-- <svgIcon name="tenge" class="icon-tenge"/> -->
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="initPrice" :min="minInitPrice" :max="maxInitPrice" :interval="interval" @change="countPriceInitPercent()"/>
                        </div>
                        <div class="precent-input">
                            <input type="number" name="pricePrecent" class="form-control" v-model.lazy="pricePercent" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{ flatsPage.on_hyp_word_mortage_time }}</label>
                            <input type="number" name="creditYear" class="form-control" v-model.lazy="creditYear" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                            <!-- <svgIcon name="calendar" class="icon-calendar"/> -->
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="creditYear" :min="minCreditYear" :max="maxCreditYear" :interval="1" @change="filterBankCards()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{flatsPage.on_hyp_word_formula}}</label>
                            <div class="calc-formula-items">
                                <div class="item-R">
                                    <input type="radio" :id="'formula_annuitet'" value="annuitet" v-model="formulaCurrent">
                                    <label :for="'formula_annuitet'" @click="calculatorCalcInit"><span>{{ flatsPage.on_hyp_word_anuitet }}</span></label>
                                </div>
                                <div class="item-R">
                                    <input type="radio" :id="'formula_equal'" value="equal" v-model="formulaCurrent">
                                    <label :for="'formula_equal'" @click="calculatorCalcInitEqual"><span>{{flatsPage.on_hyp_word_ravno_pay}}</span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="calculator-item">
                        <div class="calculator-input">
                            <div class="item-check">
                                <input type="checkbox" id="electro_btn" v-model="proofIncom" @change="filterBankCards()"> 
                                <label for="electro_btn"><span>С подтверждением дохода</span></label>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="col-anounce-desc">
                    <div class="anounce-part-one">
                        <!-- <svgIcon name="red-alert-icon" class="icon-alert"/> -->
                        <p>{{ flatsPage.flats_cards_info.hypothec_anounce_one }}</p>
                    </div>
                    <div class="anounce-part-two" v-if="flatsCardParams.complexData != null">
                        <p>{{ flatsCardParams.complexData.project_zakon_desc }}</p>
                    </div>
                </div>
            </div>
            <div class="column-right">
                <div class="hypothec-bank-cards-container">
                    <div class="status-cards online-cards">
                        <h4>{{ flatsPage.on_hyp_word_title_onhyp }}</h4>
                        <div class="empty-msg" v-if="bankCardsSet != null && bankCardsSet.filter(item => item.offline == null || item.offline == undefined).length == 0">
                            <strong>{{ flatsPage.on_hyp_msg_empty_online }}</strong>
                            <p>{{ flatsPage.on_hyp_msg_change_params }}</p>
                        </div>
                        <flatsCardPaymentHypothecItems :formulaCurrent="formulaCurrent" :flatFullPrice="flatFullPrice" :creditYear="creditYear" :complexCity="flatsCardParams.complexData.city_name.slug" :appsID="flatsCardParams.appsID" :bankCardsSet="bankCardsSet != null && bankCardsSet.filter(item => item.offline == null || item.offline == undefined)"></flatsCardPaymentHypothecItems>
                    </div>
                    <div class="status-cards offline-cards">
                        <h4>{{ flatsPage.on_hyp_word_title_offhyp }}</h4>
                        <div class="empty-msg" v-if="bankCardsSet != null && bankCardsSet.filter(item => item.offline != null && item.offline == true).length == 0">
                            <strong>{{ flatsPage.on_hyp_msg_empty_offline }}</strong>
                            <p>{{ flatsPage.on_hyp_msg_change_params }}</p>
                        </div>
                        <flatsCardPaymentHypothecItems :formulaCurrent="formulaCurrent" :flatFullPrice="flatFullPrice" :creditYear="creditYear" :bankCardsSet="bankCardsSet != null && bankCardsSet.filter(item => item.offline != null && item.offline == true)"></flatsCardPaymentHypothecItems>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import flatsCardPaymentHypothecItems from '@/components/flats-crm/flats-crm-card-payment-hypothec-items.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    import {mapGetters} from 'vuex'
    // import cookie from 'vue-cookie'
    // const https = require('https');
    // var querystring = require('querystring');
    // const tokenAuthCrm = cookie.get('crm_auth_token_test_crm');
    export default {
        name: 'flat-crm-card-payment-hypothec',
        props: ['flatsCardParams'],
        components: {
            VueSlider,
            svgIcon,
            flatsCardPaymentHypothecItems,
        },
        data () {
            return {
                initPrices: false,
                flatFullPrice: null,
                minInitPrice: null,
                maxInitPrice: null,
                // minInitialPay: null,
                // maxInitialPay: null,
                minCreditYear: 1,
                maxCreditYear: 30,
                interval: 1,
                initPrice: null, // Первоначальный взнос
                pricePercent: null, // Процент от стоимости квартиры в соотношение к первоначальному взносу
                creditYear: 15, // Срок кредитования, годывых:
                formulaCurrent: 'annuitet',
                proofIncom: true,
                // vars for total amount
                bankCardsSet: null,
                bankCards: [
                    // {
                    //     langValue1: 'Halyk Bank', // название банка
                    //     hypothecName: 'Ипотека от Halyk Bank',
                    //     logoBank: window.url + 'media/bank-smart-logo6.svg',
                    //     offline: true,
                    //     mortgageTerms: [ // Ипотечные условия
                    //         {
                    //             bet: 6.5, // Cтавка
                    //             initialFee : "20-29", // Первоначальный взнос
                    //             loanTerm : "13-24", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         },
                    //         {
                    //             bet: 13, // Cтавка
                    //             initialFee : "60-100", // Первоначальный взнос
                    //             loanTerm : "61-120", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         },
                    //         {
                    //             bet: 22.2, // Cтавка
                    //             initialFee : "50-100", // Первоначальный взнос
                    //             loanTerm : "120-240", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         }
                    //     ],
                    // },
                    // {
                    //     langValue1: 'Bank CenterCredit', // название банка
                    //     hypothecName: 'Доступная ипотека от Bank CenterCredit',
                    //     logoBank: window.url + 'media/bank-new-logo-002.svg',
                    //     offline: true,
                    //     mortgageTerms: [ // Ипотечные условия
                    //         {
                    //             bet: 11.5, // Cтавка
                    //             initialFee : "20-29", // Первоначальный взнос
                    //             loanTerm : "12-120", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         },
                    //         {
                    //             bet: 14.5, // Cтавка
                    //             initialFee : "60-100", // Первоначальный взнос
                    //             loanTerm : "121-240", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         },
                    //         {
                    //             bet: 24.5, // Cтавка
                    //             initialFee : "60-100", // Первоначальный взнос
                    //             loanTerm : "241-380", // Период займа в месяцах
                    //             withProofOfIncome : true // Подтверждение дохода
                    //         },
                    //     ],
                    // },
                    // {
                    //     bankName: 'Altyn Bank', // название банка
                    //     hypothecName: 'Ипотека от Altyn Bank',
                    //     logoBank: window.url + 'media/2023/12/bank-smart-logo2.svg',
                    //     minInitialPay: 35, // первоначальный взнос в процентах - минимальный
                    //     maxInitialPay: 85, // первоначальный взнос в процентах - максимальный
                    //     minYearCredit: 15, // срок кредитования - минимальный - лет
                    //     maxYearCredit: 25, // срок кредитования - максимальный - лет
                    //     creditRate: 15.4, // процентная ставка номинальная
                    // },
                    
                    // {
                    //     bankName: 'RBK BANK', // название банка
                    //     hypothecName: 'Ипотека от RBK Bank',
                    //     logoBank: window.url + 'media/2023/12/bank-smart-logo.svg',
                    //     minInitialPay: 15, // первоначальный взнос в процентах - минимальный
                    //     maxInitialPay: 80, // первоначальный взнос в процентах - максимальный
                    //     minYearCredit: 8, // срок кредитования - минимальный - лет
                    //     maxYearCredit: 32, // срок кредитования - максимальный - лет
                    //     creditRate: 7.4, // процентная ставка номинальная
                    // },
                    // {
                    //     bankName: 'Otbasy Bank', // название банка
                    //     hypothecName: 'Ипотека ШАНЫРАК от Otbasy Bank',
                    //     logoBank: window.url + 'media/2023/12/bank-smart-logo7.svg',
                    //     minInitialPay: 30, // первоначальный взнос в процентах - минимальный
                    //     maxInitialPay: 95, // первоначальный взнос в процентах - максимальный
                    //     minYearCredit: 10, // срок кредитования - минимальный - лет
                    //     maxYearCredit: 30, // срок кредитования - максимальный - лет
                    //     creditRate: 5.2, // процентная ставка номинальная
                    // },
                    // {
                    //     bankName: 'Forte Bank', // название банка
                    //     hypothecName: 'Ипотека от Forte Bank',
                    //     logoBank: window.url + 'media/2023/12/bank-smart-logo4.svg',
                    //     minInitialPay: 50, // первоначальный взнос в процентах - минимальный
                    //     maxInitialPay: 92, // первоначальный взнос в процентах - максимальный
                    //     minYearCredit: 20, // срок кредитования - минимальный - лет
                    //     maxYearCredit: 40, // срок кредитования - максимальный - лет
                    //     creditRate: 40.3, // процентная ставка номинальная
                    // },
                ],
                bankCardsOnline: {

                }
            }
        },
        computed: {
            ...mapGetters({
                flatsPage: 'loadFlatsPage',
                URLrocketLC: 'loadUrlRocketLC',
                isMobileChecker: 'loadIsMobileChecker',
            }),
        },
        methods: {
            buildCalculatorParams() {
                this.initPrices = true;
                var flatFullPrice = parseFloat(this.flatsCardParams.price.replaceAll('.', '')); // полная стоимость квартиры
                let minInitPrice = flatFullPrice * 10/100; // минимально допустимое значение ползунка первоначального взноса
                let maxInitPrice = flatFullPrice * 95/100; // максимально допустимое значение ползунка первоначального взноса
                let currentPrice = flatFullPrice * 0.5; // установка дефолтного значения ползунка первоначального взноса - по стандарту 50% от стоимости квартиры
                let currentPricePrecent = 50; // установка дефолтного значения первоначального взноса в процентах % 

                this.flatFullPrice = flatFullPrice;
                this.initPrice = currentPrice;
                this.minInitPrice = minInitPrice;
                this.maxInitPrice = maxInitPrice;
                this.pricePercent = currentPricePrecent;

                this.filterBankCards();

                // console.log(flatFullPrice, maxInitialPay, minInitialPay, minYearCredit, maxYearCredit)
                // console.log(minInitPrice, maxInitPrice, currentPrice, currentPricePrecent);
            },
            countPriceInitPercent() {
                var precent = Math.floor((this.initPrice/this.flatFullPrice) * 100);
                // console.log(precent, this.paymentMin)
                if (precent < this.paymentMin) {
                    this.initPrice = Math.floor((this.flatFullPrice * this.paymentMin) / 100);
                    this.pricePercent = Math.floor((this.initPrice/this.flatFullPrice) * 100);
                } else if (precent > 95) {
                    this.pricePercent = 95;
                    this.initPrice = Math.floor((this.flatFullPrice * 95) / 100);
                } else {
                    this.pricePercent = precent;
                }
                this.filterBankCards();
            },
            filterBankCards() {
                // console.log('asdasdasd', this.creditYear * 12, this.pricePercent)
                var loanTerm = this.creditYear * 12; // Срок кредитования
                var initialFee = this.pricePercent; // Первоначальный взнос
                var proofIncom = this.proofIncom;
                var bankCardsArr = [];
                bankCardsArr = this.bankCards;
                const filteredData = bankCardsArr.map(bankCard => {
                    // Фильтруем mortgageTerms для каждого объекта bankCard
                    const filteredMortgageTerms = bankCard.mortgageTerms.filter(term => {
                        const [minTerm, maxTerm] = term.loanTerm.split('-').map(Number);
                        const [minFee, maxFee] = term.initialFee.split('-').map(Number);
                        const selectedTerm = parseInt(loanTerm);
                        const selectedFee = parseInt(initialFee);

                        // Оставляем только те объекты, которые соответствуют параметру loanTermFilter
                        return selectedTerm >= minTerm && selectedTerm <= maxTerm &&
                               selectedFee >= minFee && selectedFee <= maxFee &&
                               term.withProofOfIncome == proofIncom;
                    });
                    // console.log(filteredMortgageTerms, 'TERMS')
                    // Обновляем mortgageTerms в bankCard
                    bankCard.mortgageTerms_Set = filteredMortgageTerms;
                    return bankCard;
                }).filter(bankCard => bankCard.mortgageTerms_Set.length > 0);

                // console.log(filteredData, 'FILTERED DATA');
                this.bankCardsSet = filteredData;
                // console.log(this.formulaCurrent, 'FORMULA NAME')

                if (this.formulaCurrent == 'annuitet') {
                    this.calculatorCalcInit();
                } else {
                    this.calculatorCalcInitEqual();
                }

                // console.log(this.bankCardsSet)
            },
            calculatorCalcInit() { // -------------------- РАСЧЕТ ПО АНУИТЕНТНОЙ ФОРМУЛЕ ПЛАТЕЖА
                var bankAmount = Number(this.flatFullPrice - this.initPrice); // Сумма займа 
                for (var i=0; i < this.bankCardsSet.length; i++) {
                    var payMonth = Number((this.bankCardsSet[i].mortgageTerms_Set[0].bet / 12) / 100); // Ставка в месяц
                    var koef = (payMonth * (Math.pow(1 + payMonth,  this.creditYear * 12))) / (Math.pow(1 + payMonth, this.creditYear * 12) - 1);  // Коэффициент аннуитета
                    var resultPayMonth = (bankAmount * koef).toFixed(); // Ежемесячный платеж
                    var totalBankAmount = resultPayMonth * (this.creditYear * 12); // Общая сумма займа с процентами
                    var overBankAmount = totalBankAmount - bankAmount; // Сумма переплаты от суммы займа с процентами
                    var totalFlatPrice = Number(totalBankAmount) + Number(this.initPrice); // Общая стоимость жилья с ипотекой
                    Object.assign(this.bankCardsSet[i], {
                        'bankAmount': bankAmount,
                        'payMonth' : resultPayMonth,
                        'totalBankAmount' : totalBankAmount,
                        'overBankAmount' : overBankAmount,
                        'totalFlatPrice' : totalFlatPrice,
                        'EffectiveRate': this.calculateEffectiveInterestRate(this.bankCardsSet[i].mortgageTerms_Set[0].bet, 12) // РАСЧЕТ ГЭСВ в процентах
                    });
                }
            },  
            calculatorCalcInitEqual() { //  -------------------- РАСЧЕТ ПЛАТЕЖА ПО ФОРМУЛЕ РАВНЫМИ ДОЛЯМИ
                var paymentSchedule = [];
                var totalPaymentSchedule;
                var averageMonthlyPayment = 0;
                var bankAmount = Number(this.flatFullPrice - this.initPrice); // Сумма займа 
                for (var i = 0; i < this.bankCardsSet.length; i++) {
                    var payMonth = Number((this.bankCardsSet[i].mortgageTerms_Set[0].bet / 12) / 100); // Ставка в месяц
                    var monthlyPayment = (bankAmount / (this.creditYear * 12)) + (((bankAmount * (this.bankCardsSet[i].mortgageTerms_Set[0].bet / 100)) * 30) / 360); // Ежемесячный платеж
                    // var totalBankAmount = monthlyPayment * (this.creditYear * 12); // Общая сумма займа с процентами
                    // var overBankAmount = totalBankAmount - bankAmount; // Сумма переплаты от суммы займа с процентами
                    // var totalFlatPrice = Number(totalBankAmount) + Number(this.initPrice); // Общая стоимость жилья с ипотекой
                    // Расчет графика платежей
                    paymentSchedule = this.calculatePaymentSchedule(bankAmount, this.creditYear * 12, this.bankCardsSet[i].mortgageTerms_Set[0].bet / 100, 12);
                    // Расчет общая сумма всех платежей
                    totalPaymentSchedule = this.calculateTotalPaymentOfSchedule(paymentSchedule);
                    var totalBankAmount = Number(totalPaymentSchedule) + Number(this.initPrice); // Общая сумма займа с процентами
                    var overBankAmount = totalBankAmount - this.flatFullPrice; // Сумма переплаты от суммы займа с процентами
                    var totalFlatPrice = totalBankAmount; // Общая стоимость жилья с ипотекой
                    // console.log(this.initPrice, totalPaymentSchedule, totalBankAmount)
                    // Расчет среднемесячного взноса
                    averageMonthlyPayment = this.calculateAverageMonthlyPayment(paymentSchedule, this.creditYear * 12);
                    // console.log(paymentSchedule, 'ГРАФИК')
                    // console.log(averageMonthlyPayment, 'Среднемесячный платеж')
                    Object.assign(this.bankCardsSet[i], {
                        'bankAmount': bankAmount,
                        'payMonth': averageMonthlyPayment,
                        'totalBankAmount': totalBankAmount,
                        'overBankAmount': Math.round(overBankAmount),
                        'totalFlatPrice':  Math.round(totalFlatPrice),
                        'EffectiveRate': this.calculateEffectiveInterestRate(this.bankCardsSet[i].mortgageTerms_Set[0].bet, 12) // РАСЧЕТ ГЭСВ в процентах
                    });
                }
            },
            calculateDP(S, n, OD, i, k) {
                const principalPayment = S / n;
                const interestPayment = (OD * i * 30) / 360;
                const totalPayment = principalPayment + interestPayment;
                return {
                    dp: Math.round(totalPayment),
                    principal: Math.round(principalPayment),
                    interest: Math.round(interestPayment),
                };
            },
            calculatePaymentSchedule(S, n, i, k) {
                var paymentSchedule = [];
                let OD = S; // Начальный остаток долга равен первоначальной сумме кредита
                for (let month = 0; month < n; month++) {
                    const { dp, principal, interest } = this.calculateDP(S, n, OD, i, k);
                    paymentSchedule.push({ dp, principal, interest, od: OD });
                    OD -= principal; // Обновляем остаток долга
                }
                console.log(paymentSchedule)
                return paymentSchedule;
            },
            calculateAverageMonthlyPayment(arr, n) {
                const totalPayment = arr.reduce((sum, payment) => sum + payment.dp, 0);
                return Math.round(totalPayment / n);
            },
            calculateTotalPaymentOfSchedule(paymentSchedule) {
                let totalPayment = 0;
                paymentSchedule.forEach(payment => {
                    totalPayment += payment.dp; // Суммируем все ежемесячные платежи (dp)
                });
                console.log(totalPayment,'totalPayment')
                return totalPayment;
            },
            calculateEffectiveInterestRate(rate, periods) { // Расчет ГЭСВ в процентах на основе 12 периодов капитализаций в год
                let nominalRate = rate / 100; // Преобразование процентной ставки в десятичное значение
                let effectiveRate = Math.pow((1 + (nominalRate / periods)), periods) - 1;
                return (effectiveRate * 100).toFixed(2); // Переводим обратно в проценты и округляем до двух знаков после запятой
            },
            validateInput(e) {
                // console.log(e.target.value, e.target.name, 'asdasdasdasd');
                if (e.target.name == 'initPrice') {
                    if (parseInt(e.target.value) < this.minInitPrice) {
                        e.target.value = this.minInitPrice;
                        this.initPrice = this.minInitPrice;
                    } else if (parseInt(e.target.value) > this.maxInitPrice) {
                        e.target.value = this.maxInitPrice;
                        this.initPrice = this.maxInitPrice;
                    }
                    this.countPriceInitPercent();
                } else if (e.target.name == 'pricePrecent') {
                    if (parseInt(e.target.value) < this.minInitialPay) {
                        e.target.value = this.minInitialPay;
                        this.pricePercent = this.minInitialPay;
                    } else if (parseInt(e.target.value) > this.maxInitialPay) {
                        e.target.value = this.maxInitialPay;
                        this.pricePercent = this.maxInitialPay;
                    }
                    this.getInitPriceByPrecent();
                } else if (e.target.name == 'creditYear') {
                    if (parseInt(e.target.value) < this.minCreditYear) {
                        e.target.value = this.minCreditYear;
                        this.creditYear = this.minCreditYear;
                    } else if (parseInt(e.target.value) > this.maxCreditYear) {
                        e.target.value = this.maxCreditYear;
                        this.creditYear = this.maxCreditYear;
                    }
                }
                this.filterBankCards();
            },
            getInitPriceByPrecent() {
                setTimeout(() => {
                    this.initPrice = this.flatFullPrice * this.pricePercent/100;
                }, 300);
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            // getNumberCorrection(n) {
            //     return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            // },
            getNumberCorrection(n) {
                let num = n;
                if (typeof n === 'string') {
                    const str = n.trim();
                    const lastDot   = str.lastIndexOf('.');
                    const lastComma = str.lastIndexOf(',');

                    if (lastComma > lastDot) {
                        num = parseFloat(str.replace(/\./g, '').replace(',', '.'));
                    } else {
                        num = parseFloat(str.replace(/,/g, ''));
                    }
                }

                if (isNaN(num)) return '0';

                // 🔥 Округляем до целых — копейки не показываем
                return String(Math.round(num))
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
            },
            getOnlineBankList() {
                axios.post(window.CRMProxy + '/v1/banks', {}).then((response) => {
                    var arrBankItems = response.data.body.dictionaryValueList;
                    for (var i = 0; i < arrBankItems.length; i++) {
                        this.bankCards.push(arrBankItems[i])
                    }
                    this.getActualFlatPrice();
                }).catch((error) => {
                    if (error.response) {
                        console.error('Response Error:', error.response.status);
                    } else if (error.request) {
                        console.error('Request Error:', error.request);
                    } else {
                        console.error('Setup Error:', error.message);
                    }
                })
            },
            getActualFlatPrice() {
                var flatID = this.flatsCardParams.appsID;
                // console.log(this.flatsCardParams.appsID)
                axios.post(window.CRMProxy + '/v1/compartment', {
                    apartmentId: flatID,
                    languageCode: 'ru'
                }).then(async (response) => {
                    // console.log(response, 'Compartments Info');
                    if (response.data != null) {
                        if (response.data.data.paymentOptions != null && response.data.data.paymentOptions.length > 0) {
                            var dataArr = response.data.data.paymentOptions;
                            var getHypotecParam = dataArr.filter((item) => {
                                return item.name == 'Ипотека'
                            });
                            // console.log(getHypotecParam)
                            // console.log(dataArr, 'dataArr')
                            if (getHypotecParam.length > 0) {
                                this.flatsCardParams.price = this.getNumberCorrection(getHypotecParam[0].compartmentPrice);
                                this.flatsCardParams.price_meter = this.getNumberCorrection(getHypotecParam[0].meterPrice);
                                this.buildCalculatorParams();
                                // console.log(this.flatsCardParams)
                            } else {
                                this.buildCalculatorParams();
                            }
                        } else {
                            this.buildCalculatorParams();
                        }
                    } else {
                        this.buildCalculatorParams();
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Запрос совершен, но сервер вернул код состояния отличный от 2xx
                        console.error('Response Error:', error.response.status);
                    } else if (error.request) {
                        // Запрос совершен, но не получен ответ
                        console.error('Request Error:', error.request);
                    } else {
                        // Произошла ошибка настройки запроса
                        console.error('Setup Error:', error.message);
                    }
                })
            },
            getOfflineBankList() {
                const bankItems = this.flatsPage.on_hyp_bank_list;
                const projectName = this.flatsCardParams.complexData.project_name.name;
                if (bankItems.length > 0) {
                    // const filterProjects = (projects, projectName) => {
                    //     return projects.filter(project => 
                    //         project.project_init.some(init => init.slug.toLowerCase() === projectName.toLowerCase())
                    //     );
                    // };
                    const filterProjects = (projects, projectName) => {
                        return projects.filter(project => 
                            project.project_init && // Проверка, что project_init существует и не равен false
                            Array.isArray(project.project_init) && // Проверка, что project_init является массивом
                            project.project_init.some(init => init.slug.toLowerCase() === projectName.toLowerCase())
                        );
                    };
                    const filteredProjects = filterProjects(bankItems, projectName);
                    for (var i=0; i < filteredProjects.length; i++) {
                        this.bankCards.push(filteredProjects[i])
                    }
                } else {
                    return false;
                }
                // console.log(bankItems, this.flatsCardParams.complexData.project_name.name)
                // console.log(filteredProjects, 'RESULT')
            },
        },
        created () {
            this.getOfflineBankList();
            this.getOnlineBankList();
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.projectItems,
            //     (newValue) => {
            //         if (newValue) {
            //            this.getComplexData();
            //         }
            //     }
            // );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card-payment-hypothec.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-card-payment-hypothec-respond.scss';
    // @import '@/styles/components/flats-page/flats-card.scss';
    // @import '@/styles/components/flats-page/respond/flats-card-respond.scss';
</style>